import React from "react";
import { UIFlightData } from "@flights/types";
import useRyanairHungaryInfoController from "./useRyanairHungaryInfo.controller";
import { Icon, Stack, Text } from "@bookingcom/bui-react";
import { InfoSignIcon } from "@bookingcom/bui-assets-react/streamline";
import useRouteName from "../../../../../../../hooks/useRouteName";
import useProfiler from "../../../../../../../hooks/useProfiler";
import flights_web_condensed_extras_fd_mdot from "../../../../../../../utils/experiments/funnel/flights_web_condensed_extras_fd_mdot";

const useRyanairHungaryInfo = (flight: UIFlightData) => {
  const { header, ryanairHungarytext } = useRyanairHungaryInfoController(flight);

  const routeName = useRouteName();
  const { isMobile } = useProfiler();
  const condensedFDMobile =
    routeName == "flightdetails" && isMobile() && !!flights_web_condensed_extras_fd_mdot.trackWithDefaultStage();

  if (!ryanairHungarytext) return undefined;

  return {
    header,
    content: (
      <Stack direction="row" gap={4}>
        <Icon svg={InfoSignIcon} size={condensedFDMobile ? "medium" : "large"} />
        <Stack.Item grow={true}>
          <Text variant="body_2">{ryanairHungarytext}</Text>
        </Stack.Item>
      </Stack>
    )
  };
};

export default useRyanairHungaryInfo;
